const ALLOWED_TAGS = new Set(['SPAN', 'STRONG', 'BR', 'EM']);
const ALLOWED_CLASSES = new Set(['home-para-mi__title-accent']);
const ACCENT_CLASS = 'home-para-mi__title-accent';
const MARKUP_PATTERN = /<(span|strong|br|em)\b/i;
/** Detecta «para mí?» / «para mi?» al final del título (plain text). */
const ACCENT_PLAIN_PATTERN = /(para\s+m[ií]\??)\s*$/i;

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Aplica degradado: si hay HTML permitido lo sanitiza;
 * si es texto plano, envuelve «para mí?» en el span accent.
 */
export function prepareParaMiTitleHtml(raw: string): string {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) {
    return '';
  }

  if (!MARKUP_PATTERN.test(trimmed)) {
    return wrapPlainAccent(escapeHtml(trimmed));
  }

  if (typeof DOMParser === 'undefined') {
    return wrapPlainAccent(escapeHtml(trimmed));
  }

  const doc = new DOMParser().parseFromString(trimmed, 'text/html');
  const sanitized = serializeAllowedNodes(doc.body).trim();
  if (sanitized.includes(ACCENT_CLASS)) {
    return sanitized;
  }
  return wrapPlainAccent(sanitized);
}

function wrapPlainAccent(escapedOrSafeText: string): string {
  const match = ACCENT_PLAIN_PATTERN.exec(escapedOrSafeText);
  if (!match || match.index === undefined) {
    return escapedOrSafeText;
  }
  const before = escapedOrSafeText.slice(0, match.index);
  const accent = match[1];
  return `${before}<span class="${ACCENT_CLASS}">${accent}</span>`;
}

function serializeAllowedNodes(parent: ParentNode): string {
  let html = '';

  parent.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      html += escapeHtml(node.textContent ?? '');
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const element = node as HTMLElement;
    const tag = element.tagName;

    if (!ALLOWED_TAGS.has(tag)) {
      html += serializeAllowedNodes(element);
      return;
    }

    if (tag === 'BR') {
      html += '<br>';
      return;
    }

    const classes = [...element.classList].filter((className) =>
      ALLOWED_CLASSES.has(className)
    );
    const classAttr = classes.length ? ` class="${classes.join(' ')}"` : '';
    const tagName = tag.toLowerCase();

    html += `<${tagName}${classAttr}>${serializeAllowedNodes(element)}</${tagName}>`;
  });

  return html;
}
